import React, {PureComponent} from "react"
import {match as Match} from "react-router-dom"

import {IndexRedirect, PartialRoute} from "@irati/utils/history/routing"

import ProtectedTeamsList from "../containers/ProtectedTeams/List"

interface Props {
  match: Match
}

class ProtectedTeamsSettings extends PureComponent<Props> {
  render() {
    const {match} = this.props

    return (
      <>
        <IndexRedirect match={match} to="/view" />
        <PartialRoute component={ProtectedTeamsList} exact match={match.url} path="/view" title="Countries" />
      </>
    )
  }
}

export default ProtectedTeamsSettings
